import Wrapper from "./Wrapper";
import Properties from "./Properties";
import Activity from "./Activity";

export default { Wrapper, Properties, Activity };
